<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      模版管理
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.templateCode"
          placeholder="模版code"
          class="public-inp md5"
        />
        <Input
          v-model="query.queryString"
          placeholder="查询字符串"
          class="public-inp md5"
        />
        <span class="public-stretch" @click="open = !open">
          <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" />{{
            open ? "收起" : "展开"
          }}
        </span>
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="addFn()"
          v-access="'datax.template.add'"
          >添加模版</Button
        >
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'datax.template.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'datax.template.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="javascript:;"
              @click="editFn(row)"
              v-access="'datax.template.edit'"
              >编辑</a
            >
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              v-access="'datax.template.status'"
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        queryString: "",
        templateCode: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 80,
          fixed: "left",
        },
        //   {
        //   title: '任务模版',
        //   key: 'jobTemplate',
        //   width: 170
        // },
        {
          title: "模版code",
          key: "templateCode",
          width: 200,
        },
        {
          title: "任务名称",
          key: "name",
          width: 250,
        },
        {
          title: "timeOut",
          key: "timeOut",
          width: 250,
        },
        {
          title: "描述",
          key: "remark",
          width: 170,
        },
        {
          title: "创建时间",
          key: "insertTime",
          width: 170,
        },
        {
          title: "状态",
          slot: "status",
          width: 80,
          fixed: "right",
        },
        {
          title: "更新时间",
          key: "updateTime",
          width: 150,
          fixed: "right",
        },
        {
          title: "操作",
          slot: "action",
          width: 70,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getDataXTaskTemplateList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.templateCode = "";
      this.query.queryString = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    addFn() {
      this.$router.push({
        name: "templateAdd",
      });
    },
    editFn(row) {
      this.$router.push({
        name: "templateAdd",
        query: {
          code: row.templateCode,
        },
      });
    },
    beforeStateChange() {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "切换确认",
          content: "您确认要切换状态吗？",
          onOk: resolve,
          oncancel: reject,
        });
      });
    },
    stateChange(d, v) {
      if (v) {
        this.$api
          .enableDataXTaskTemplate({ templateCode: d.templateCode })
          .then((res) => {
            if (res.code == "200") {
              this.$Message.success("模版启用成功");
              this.getList();
            } else {
              this.$Message.error("模版启用失败");
            }
          });
      } else {
        this.$api
          .disableDataXTaskTemplate({ templateCode: d.templateCode })
          .then((res) => {
            if (res.code == "200") {
              this.$Message.success("模版禁用成功");
              this.getList();
            } else {
              this.$Message.error("模版禁用失败");
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/datax/template.vue